import React, { useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { HiOutlineMail } from 'react-icons/hi'
import { newsletter } from '../../Services/webService'
import toast from 'react-hot-toast'
import Loader from '../Main/Loader'
// import { HiOutlineMail } from "react-icons/hi";


const NewsLetter = () => {


    const [email, setEmail] = useState("")
    const [isLoading, setIsLoading] = useState("")

    const handleEmail = (e) => { setEmail(e.target.value) }


    const handleSubmit = async (e) => {
        e.preventDefault();

        let body = {
            email,
        };

        setIsLoading(true);

        let response = await newsletter(body);

        if (response.code === 200) {
            toast?.success(response?.message);
            setIsLoading(false);
            setEmail("")

        } else if (response.code === 401) {
            toast?.error(response?.errors);
            setIsLoading(false);
        } else {
            // optional: show other errors
            // for (const [key, value] of Object.entries(response?.errors)) {
            //     toast?.error(value);
            // }
            setIsLoading(false);
        }
    };
    return (
        <>
            <div className="container py-5 newsletter">
                <div className="row">
                    <div className="col-12">
                        <h2 className='fw-bold text-center'>
                            Join Our Newsletter
                        </h2>

                        <div className="row justify-content-center g-2 mt-5">
                            <div className="col-lg-8">
                                <div className="row border g-0 align-items-center">
                                    <div className="col-auto px-1">
                                        <HiOutlineMail className='text-muted' size={24} />

                                    </div>
                                    <div className="col d-flex">
                                        <Form.Control onChange={handleEmail} value={email} className='border-0 p-lg-0' size="lg" type="text" placeholder="Enter your email" />
                                    </div>

                                </div>
                            </div>
                            <div className='col-auto' >
                                <Button onClick={handleSubmit} type='button' variant='dark' className='rounded-0' size='lg'>
                                    {
                                        isLoading ? <Loader /> : "Submit"
                                    }
                                </Button>
                            </div>

                            <p className='text-muted text-center mt-5'>Keep up to date with our latest news and special offers. </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default NewsLetter